import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureStockMaster
export interface IFeatureStockMaster extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_MASTER_DEFAULT
export const _FEATURE_STOCK_MASTER_DEFAULT: Readonly<IFeatureStockMaster & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockMaster,
  feature: NavigationPageEnum.StockMaster,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion